// extracted by mini-css-extract-plugin
export default {"host-promo-detail__container":"styles_host-promo-detail__container__QA6ou"};